import _omitBy from 'lodash/omitBy';
import _isEmpty from 'lodash/isEmpty';

// Helper function to remove empty properties from object
export const getPurgedObj = (obj: any) => _omitBy(obj, _isEmpty);
